import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { getSchool } from '../modules/reducers';

class Footer extends Component {
    render() {
        const { school } = this.props;

        return (
            <footer className="site-footer border-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mb-5 mb-lg-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className="footer-heading mb-4">Navigations</h3>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <ul className="list-unstyled">
                                        {/* <li><a href={`school/${this.props.schoolName}`}>Shop</a></li> */}
                                        <li><a href="">Home</a></li>
                                        <li><a href="about">About</a></li>
                                        <li><a href="contact">Contact Us</a></li>
                                        <li><a href='privacyPolicy'>Privacy Policy</a></li>
                                    </ul>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <ul className="list-unstyled">
                                        <li><a href='pricing'>Pricing</a></li>
                                        <li><a href='shippingPolicy'>Shipping Policy</a></li>
                                        <li><a href='returnPolicy'>Return & Cancellation Policy</a></li>
                                        <li><a href='termsAndConditions'>Terms and Conditions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <div className="block-5 mb-5">
                                <h3 className="footer-heading mb-4">Contact Info</h3>
                                <ul className="list-unstyled">
                                    {/* Address */}
                                    {school && school.contactAddress ? (
                                        <li className="address">{school.contactAddress}</li>
                                    ) : (
                                        <li className="address">Pelican Publishing House, Hyderabad, Telangana, 500051.</li>
                                    )}

                                    {/* Phone Numbers */}
                                    {school && school.contactNumbers && school.contactNumbers.length > 0 ? (
                                        <li className="phone">{school.contactNumbers.join(', ')}</li>
                                    ) : (
                                        <li className="phone">7207020942</li>
                                    )}

                                    {/* Email */}
                                    {school && school.contactEmail ? (
                                        <li className="email">{school.contactEmail}</li>
                                    ) : (
                                        <li className="email">pelicanpublishinghouse@gmail.com</li>
                                    )}
                                </ul>
                            </div>

                            {/* Complaints block — only shown when warehouse contact is available */}
                            {school && (school.warehouseEmail || school.warehousePhone) && (
                                <div className="block-5 mb-5">
                                    <h3 className="footer-heading mb-4">For complaints related to this school, please contact:</h3>
                                    <ul className="list-unstyled">
                                        {school.warehousePhone && (
                                            <li className="phone">{school.warehousePhone}</li>
                                        )}
                                        {school.warehouseEmail && (
                                            <li className="email">{school.warehouseEmail}</li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row pt-5 text-center">
                        <div className="col-md-12">
                            <p>
                                Copyright © All rights reserved | Pelican Edu Supply
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        );
    }
}

const mapStateToProps = state => {
    return {
        school: getSchool(state),
    }
}

const mapDispatchToProps = dispatch => ({
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Footer);
